// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { SKIP_LOADER } from './loader-context.token';
import { TenantService } from './tenant.service';

@Injectable({
    providedIn: 'root',
})
export class BackgroundService {
    private baseUrl = environment.apiUrl;

    constructor(private http: HttpClient, private tenantService: TenantService) { }

    //   getData(endpoint: string): Observable<any> {
    //     return this.http.get(`${this.baseUrl}/${endpoint}`);
    //   }

    //   postData(endpoint: string, data?: any): Observable<any> {
    //     return this.http.post(`${this.baseUrl}/${endpoint}`, data);
    //   }

    //   postBlob(endpoint: string, body: any): Observable<Blob> {
    //     return this.http.post(`${this.baseUrl}/${endpoint}`, body, { responseType: 'blob' });
    //   }

    //   putData(endpoint: string, data: any): Observable<any> {
    //     return this.http.put(`${this.baseUrl}/${endpoint}`, data);
    //   }

    //   deleteData(endpoint: string): Observable<any> {
    //     return this.http.delete(`${this.baseUrl}/${endpoint}`);
    //   }

    backgroundGet(endpoint: string,): Observable<any> {
        return this.http.get(
            `${this.baseUrl}/${endpoint}`,
            { context: new HttpContext().set(SKIP_LOADER, true) }
        );
    }

    loadPeopleList() {
        const tenantIdentifier = this.tenantService.getTenantId() || this.tenantService.getTenantKey();
        const cacheKey = `peopleListJson_${tenantIdentifier}`;
        const peopleListCached = sessionStorage.getItem(cacheKey);

        if (!peopleListCached) {
            this.backgroundGet('People/getPeople').subscribe({
                next: (data: any[]) => {
                    const cacheObject = {
                        data: data,
                        expiresAt: new Date(Date.now() + 60 * 60 * 1000).toISOString()
                    };
                    sessionStorage.setItem(cacheKey, JSON.stringify(cacheObject));
                },
                error: (err) => {
                    console.error('Failed to fetch data:', err);
                }
            });
        }
    }
}